<!-- 高标仓 -->
<template>
    <div class="high-box">
        <div class="high-top">
            <div class="high-export">
                <MessageHeader msg="仓储数据总览"></MessageHeader>
<!--                <el-button @click="exportData"><el-image :src="exportImg"/>数据导出</el-button>-->
            </div>

            <div class="data-list">
                <el-row :gutter="20">
                    <el-col :span="4" v-for="(item, key, index) in dataList" :key="key">
                        <CompareItem
                           :item="item" :name="keys[key] ? keys[key].str : ''"
                           :unit="keys[key] ? keys[key].unit : ''"
                           :process="keys[key] ? keys[key].process : ''"
                           :hiddenCircle="keys[key] ? keys[key].hiddenCircle : false"
                           :hiddenSame="keys[key] ? keys[key].hiddenCircle : false"
                           :top="28"
                           :index="index"
                           :itemBgs="[0,1,2,3,4,5,6]"
                           :tipText="keys[key].tipText"
                           :format="keys[key].format"
                        >
                        </CompareItem>
                    </el-col>
                </el-row>
            </div>

            <div class="data-chart">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="chart-style">
                            <p class="u-agg-aii-ct">租户行业分布</p>
                            <div class="chart-style-box">
                                <no-data :visible="emptyArray(dataInfo.industryDistribution)"/>
                                <PieChart :data="dataInfo.industryDistribution"></PieChart>
                            </div>
                        </div>

                    </el-col>
                    <el-col :span="12">
                        <div class="chart-style">
                            <p class="u-agg-aii-ct">市场体量分析</p>
                            <div class="chart-style-box1">
                                <Pies title="总量" :color="['#447FF8', '#AFB7C1']"
                                      :data="dataInfo.marketVolume"
                                      y-center
                                      :radius="['40%', '50%']"
                                      :legend="{
                                        left: 'center',
                                        bottom: 0,
                                        show: true,
                                        orient: 'vertical',
                                        icon: 'circle',
                                        itemWidth: 8,
                                        itemHeight: 8,
                                    }"/>
<!--                                    <div class="chart-center-style">-->
<!--                                        <span class="jiantou"></span>-->
<!--                                        <span>现有存量</span>-->
<!--                                    </div>-->
                                    <Pies title="现有存量"
                                          :color="['#BC5EEB', '#5C67FB']"
                                          :data="dataInfo.currentInventory"
                                          :radius="['30%', '38%']"
                                          y-center
                                          :legend="{
                                            left: 'center',
                                            bottom: 0,
                                            show: true,
                                            orient: 'vertical',
                                            icon: 'circle',
                                            itemWidth: 8,
                                            itemHeight: 8,
                                          }"
                                    />
                            </div>
                            
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="data-chart" style="margin-top: 20px;">
              <div class="chart-style">
                <p class="u-agg-aii-ct">预计增量</p>
                <div class="chart-style-box">
                  <high-predict-addtional
                      :data="expectNewData"
                  />
                </div>
              </div>
            </div>
        </div>

        <div class="child-list">
            <MessageHeader
                msg="子市场数据一览"
                tip-text="点击区县名称查看子市场洞察"
            />
            <div class="child-table rs-el-table">
                <el-table :data="childData">
                    <el-table-column label="序号" align="center" width="80" type="index" fixed/>
                    <el-table-column prop="areaName" label="区县" fixed>
                      <template  #default="scope">
                        <router-link class="a-area"
                                     :to="useSubMarket({areaCode: scope.row.areaCode, cityCode: code})">
                          {{scope.row.areaName}}
                        </router-link>
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="existingInventory" label="现有存量（㎡)" align="left" width="140">
                        <template #header>
                            <span class="header-lable">现有存量（㎡)
                                <el-tooltip content="建成面积（包含本季度增量）" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                        <template #default="scope">
                            <span>{{
                                    scope.row.existingInventory !== null ?  Number( scope.row.existingInventory).toLocaleString() : ''
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="quarterlyIncrease" label="本季度增量(㎡)" align="left" width="150">
                        <template #header>
                            <span class="header-lable">本季度增量（㎡)
                                <el-tooltip content="本季度建成面积" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                        <template #default="scope">
                            <span>{{ scope.row.quarterlyIncrease !== null ?  Number(scope.row.quarterlyIncrease).toLocaleString() : '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="netAbsorption" label="净吸纳量(㎡)" align="left" width="130">
                        <template #header>
                            <span class="header-lable">净吸纳量（㎡) </span>
                        </template>
                        <template #default="scope">
                            <span>{{
                                    scope.row.netAbsorption !== null ?  Number(scope.row.netAbsorption).toLocaleString() : '-'
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="vacancyRate" label="空置率" align="center" width="180">
                        <template #header>
                            <span class="header-lable">空置率</span>
                        </template>
                        <template #default="scope">
                            <span>{{vacancyRate(scope.row.vacancyRate)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="estimatedEffectiveRent" width="300" align="center">
                        <template #header>
                            <span class="header-lable">预估有效租金(元/㎡·月)
                                <el-tooltip content="折算免租期、装修期后的租金" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                        <template #default="scope">
                            <span>{{effectiveRent(scope.row.estimatedEffectiveRent)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="estimatedIncrement" width="140" label="预计增量(㎡)" align="left">
                        <template #header>
                            <span class="header-lable">预计增量（㎡)
                                <el-tooltip content="预计投入市场的面积" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                        <template #default="scope">
                            <span>{{warehouseArea(scope.row.estimatedIncrement)}}</span>
                        </template>
                    </el-table-column>

                    <!--                    <el-table-column sortable prop="averageSalesCycle" label="平均去化周期(月)">-->
                    <!--                        <template #header>-->
                    <!--                            <span class="header-lable">平均去化周期(月)-->
                    <!--                                <el-tooltip content="去化10万平所需时间" placement="bottom" effect="light">-->
                    <!--                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>-->
                    <!--                                </el-tooltip>-->
                    <!--                            </span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                </el-table>
            </div>

        </div>

        <div class="chart-list">
            <MessageHeader msg="租金与空置率情况"></MessageHeader>
            <div class="chart-items-box">
                <div class="chart-item-left">
                    <p class="u-agg-aii-ct">预估有效租金和空置率趋势</p>
                    <BarAndLineChart
                      color="#0A9BFC"
                      :linearGradient="['rgba(10, 155, 252, 0.8)','rgba(255, 255, 255, 0)']"
                      :options="['name', 'rent', 'vacancyRate']"
                      :labelOptions="['', '']"
                      :label-format="['(元/㎡·月)','']"
                      :data="timeList"
                      :value-format="[rentPriceFormat, vacancyRateWithSuffix]"
                      :showLabel="['预估有效租金', '空置率']"
                    />
                </div>
                <div class="chart-item-right">
                    <p class="u-agg-aii-ct">品牌开发商预估有效租金和空置率趋势</p>
                    <BarAndLineChart
                    color="#31C9E8"
                    :linearGradient="['rgba(49, 201, 232, 0.8)','rgba(255, 255, 255, 0)']"
                    :options="['name', 'rent', 'vacancyRate']"
                    :labelOptions="['', '']"
                    :label-format="['(元/㎡·月)','']"
                    :data="devList"
                    :value-format="[rentPriceFormat, vacancyRateWithSuffix]"
                    :showLabel="['预估有效租金', '空置率']"
                    ></BarAndLineChart>
                </div>
            </div>
            <!-- <div class="chart-item">
                <BarAndLine
                    title="预估有效租金和空置率趋势"
                    notShowYName
                    :legend-data="['预估有效租金（元/㎡·月）', '空置率']"
                    :color="['#2C5FE1','#76BAFF', '#FE9A0A']"
                    :showLine="2" :data="timeList"
                    :options="['name', 'rent', 'vacancyRate']"
                    :percentage="['vacancyRate']"/>
            </div>
            <div class="chart-item">
                <BarAndLine
                    title="品牌开发商预估有效租金与空置率情况"
                    notShowYName
                    :legend-data="['预估有效租金（元/㎡·月）', '空置率']"
                    :color="['#0053C2','#41D1FF', '#FE9A0A']"
                    :showLine="0"
                    :data="devList"
                    :options="['name', 'rent', 'vacancyRate']"
                    :percentage="['vacancyRate']"/>
            </div> -->

        </div>
<!--品牌开发商-->
      <div class="dynamic-box">
        <MessageHeader msg="品牌开发商数据对比"></MessageHeader>
        <div class="dynamic-table"  style="position: relative;">
<!--          <ScrollTable-->
<!--              :tableHead="brandDeveloperHeader"-->
<!--              :table-data="formatBrandDeveloperData"-->
<!--          />-->
<!--          class="top"-->
          <div class="scroll-table rs-el-table" >
            <el-table
                style="width: 100%" height="250"
                :data="formatBrandDeveloperData"
                header-row-class-name="tableHeader"
                :header-cell-style="{'text-align':'center'}"
            >
              <el-table-column
                  v-for="item in brandDeveloperHeader"
                  :prop="item.props"
                  :label="item.label"
                  :key="item.label"
                  :width="item.width||''"
                  :type="item.type"
                  :align="item.align"
              >
                <template v-if="item.tipText" #header>
                  <span class="header-lable">{{item.label}}
                      <el-tooltip :content="item.tipText" placement="top" effect="light">
                          <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65" style="font-size: 12px;"></i>
                      </el-tooltip>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <high-brand-developer-search
            :code="props.code"
            @onSearch="getBrandDeveloperData"
          />
          <span class="reset-button" @click="resetBrandDeveloperData">重置</span>
        </div>
      </div>

      <div class="dynamic-box">
          <MessageHeader msg="租赁市场动态"></MessageHeader>
          <div class="dynamic-table">
              <ScrollTable :tableHead="tableHead" :table-data="dynamicsData"/>
          </div>
      </div>

    </div>
</template>
<script setup>
import request from "@/service/request";
import {
  dynamicsHighTable,
  exportCityHigh,
  exportCityHighTime,
  GetHighStandardDeveloperInfo,
  GetHighStandardExpectNewData,
  getRentAndVacanciesDeveloper,
  getRentAndVacanciesTime,
  getWarehouseChildData,
  getWarehouseData
} from "@/service/api";
import {computed, onMounted, ref, watch} from "vue";
import CompareItem from '@/components/compareItem'
import MessageHeader from '@/components/MessageHeader'
import Pies from '@/components/charts/chartsPie'
import ScrollTable from '@/components/scrollTable'
import PieChart from '@/components/charts/nChartsPie.vue'
import BarAndLineChart from '@/components/charts/nChartBarAndLine.vue'
import {exportFile} from "@/tool/public";
import HighPredictAddtional from "@/view/insight/urban/components/highPredictAddtional.vue";
import HighBrandDeveloperSearch from "@/view/insight/urban/components/highBrandDeveloperSearch.vue";
import {useRouter} from "vue-router";
import {useSubMarket} from "@/router/linkroute";
import {
  effectiveRent, emptyArray,
  keys,
  rentPriceFormat, vacancyRate,
  vacancyRateNoMultiply,
  vacancyRateNoSuffixMultiply, vacancyRateWithSuffix,
  warehouseArea
} from "@/tool/number";
import NoData from "@/components/noData.vue";
let mapTime = localStorage.getItem('mapTime')


/**品牌开发商**/
const brandDeveloperData = ref([]);
const formatBrandDeveloperData = computed(() => {
  return brandDeveloperData.value.map(e => {
    return {
      ...e,
      vacancyRate: vacancyRateNoMultiply(e.vacancyRate),
      expectNew: warehouseArea(e.expectNew),
      areaTotal: warehouseArea(e.areaTotal),
      effectiveRent: rentPriceFormat(e.effectiveRent)
    }
  })
})

const brandDeveloperHeader = ref([
  {label: '序号', width: 70, type: 'index', align: 'center'},
  {props: 'projectDeveloper', label: '开发商', showSelect: true},
  {props: 'areaTotal', label: '现有存量（㎡）', width: 150, tipText: '建成面积（包含本季度增量）'},
  {props: 'curCount', label: '存量项目数量（个）', align: 'center', width: 160},
  {props: 'effectiveRent', label: '预估有效租金（元/㎡·月）', align: 'center', width: 220, tipText: '折算免租期、装修期后的租金'},
  {props: 'vacancyRate', label: '空置率', align: 'center', width: 90},
  {props: 'expectNew', label: '预计增量（㎡）', width: 150, tipText: '预计投入市场的面积'},
  {props: 'expectCount', label: '增量项目数量（个）', align: 'center', width: 180},
])

const resetBrandDeveloperData = async () => {
  brandDeveloperData.value = [];
  await getBrandDeveloperData();
}
const getBrandDeveloperData = async (developerList) => {
  let {data} = await request({
    method: 'get',
    url: GetHighStandardDeveloperInfo,
    data: {
      cityCode: props.code,
      developerList
    }
  })
  brandDeveloperData.value = data;
}

// 导出
const exportData = async () => {
    let data = await request({
        url: exportCityHigh,
        method: 'post',
        data: {
            quarter:[mapTime]
        },
        download: true,
        responseType: 'blob',
    })
    await exportTime()
    exportFile(data, '高标仓城市层级数据')
}
const exportTime = async () => {
    let data = await request({
        url: exportCityHighTime,
        method: 'post',
        data: {
            quarter:[mapTime]
        },

    })
}

const props = defineProps({
    code: {
        type: String,
        default: ''
    }
})

watch(props, () => {
    getExpectNewData()
    getWarehouse()
    getChildData()
    getChartInfo()
    getDynamicsData()
    getBrandDeveloperData();
})


let dataInfo = ref({})
/** 高标仓数据总览对应关系  **/
// const keys = reactive({
//     existingInventoryMetric: {str: '现有存量', unit: '㎡', tipText: "建成面积（包含本季增量）"},
//     quarterlyIncreaseMetric: {str: '本季度增量', unit: '㎡', tipText: "本季度建成面积"},
//     netAbsorptionMetric: {str: '净吸纳量', unit: '㎡', hiddenSame: true, hiddenCircle: true},
//     vacancyRateMetric: {str: '空置率', process: '%'},
//     estimatedEffectiveRentMetric: {str: '预估有效租金', unit: '元/㎡·月', tipText: "折算免租期、装修期后的租金"},
//     estimatedIncrementMetric: {str: '预计增量', unit: '㎡', tipText: "未来三年预计投入市场的面积"},
//     // estimatedSalesCycleMetric: { str: '预计去化周期', unit: '月', tipText: "去化10万平所需时间" },
// })

const color = ['#447FF8', '#5C67FB', '#BC5EEB', '#F9545A', '#F99807', '#FFC70D', '#7FCD49']

const dataList = ref({})

/**仓储数据总览**/
const getWarehouse = async () => {
    let {data} = await request({
        url: getWarehouseData,
        method: 'get',
        data: {cityCode: props.code}
    })
    console.log('////////////--------------');
    
    console.log(data);
    

    let obj = {}
    for (let key in keys) {
        obj[key] = data[key]
    }
    dataList.value = obj
    dataInfo.value = data
}
let childData = ref([])
/** 子市场数据 **/
const getChildData = async () => {
    let {data} = await request({
        url: getWarehouseChildData,
        method: 'get',
        data: {cityCode: props.code}
    })

    childData.value = data||[]
}
/***时间趋势*/
let timeList = ref([])
let devList = ref([])

const getChartInfo = async () => {
    let time = await request({
        url: getRentAndVacanciesTime,
        method: 'get',
        data: {cityCode: props.code}
    })

    let dev = await request({
        url: getRentAndVacanciesDeveloper,
        method: 'get',
        data: {cityCode: props.code}
    })
    timeList.value = time.data
    devList.value = dev.data
}

let dynamicsData = ref([])
const tableHead = ref([
    {label: '序号', align: 'center', width: 60, type: 'index'},
    {props: 'tenantName', label: '租户', align: 'left', width: 260},
    {props: 'areaName', label: '区县', width: 100, align: 'left'},
    {props: 'projectName', label: '项目名称', align: 'left'},
    {props: 'statusName', label: '状态', width: 100, align: 'left'},
    {props: 'areaValue', label: '租赁/退租面积（㎡）', isArea: true, align: 'left'},
    {props: 'estimatedClosingPrice', label: '预估成交价格（元/㎡·月）', isEstimatedPrice: true, align: 'center'},
])
/**子数据动态**/
const getDynamicsData = async () => {
    let {data} = await request({
        url: dynamicsHighTable,
        method: 'get',
        data: {cityCode: props.code}
    })
    dynamicsData.value = data
}

const router = useRouter()
const expectNew = ref([])
const expectNewData = computed(() => {
  return expectNew.value.map(e => {
    const calc = (c, n) => {
      const key = n["quarter"].substr(5);
      c[key] = n["expectValue"]
      return c;
    }
    return e['list'].reduce(calc, {year: e['year'], total: e['total']});
  })
})
const getExpectNewData = async () => {
  if(!props.code) return;
  const { data } = await request({
    method: 'get',
    url: GetHighStandardExpectNewData,
    data: {
      cityCode: props.code
    }
  })
  expectNew.value = data;
}

onMounted(() => {
    getExpectNewData()
    getWarehouse()
    getChildData()
    getChartInfo()
    getDynamicsData()
    getBrandDeveloperData();
})
</script>

<style lang="less">
@import "../index.less";

.el-table {
  .tableHeader {
    font-size: 14px;
    font-weight: 400;
    color: #333333;

    .cell {
      display: flex;
      align-items: center;
    }
  }
}

.reset-button{
  position: absolute;
  right: 20px;
  bottom: -20px;
  cursor: pointer;
  color: #1D83E6;
  user-select: none;
}


.a-area{
  cursor: pointer;
  color: #1D83E6;
  text-decoration: none;
}


.high-box {
    width: 100%;

    .high-top {
        .high-export{
            display: flex;
            justify-content: space-between;
            align-items: center;
            &>.el-button {
                width: 109px;
                height: 36px;
                background: #1477C9;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                .el-image{
                    width: 16px;
                    height: 15px;
                    margin-right: 8px;
                }
            }
        }
        .data-list {
            .el-row {
                .el-col {
                    margin-top: 20px;
                    height: 235px;
                    //margin-bottom: 20px;
                }

            }
        }

        .data-chart {
            & > .el-row {
                .el-col {
                    margin-top: 20px;
                    //margin-bottom: 20px;
                }

                .margin-0 {
                    margin: 0;
                }
            }

            .chart-style {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;
                padding-bottom: 0;
                height: 360px;
                background: #FFFFFF;
                position: relative;
                box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                .chart-style-box{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }
                .chart-style-box1{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 50px;
                    box-sizing: border-box;
                }
                .chart-style-item {
                    padding-top: 0;
                    width: 100%;
                    box-sizing: border-box;
                    height: 300px;
                    background: #FFFFFF;
                }

                .chart-title {
                    position: absolute;
                    top: 40px;
                    z-index: 9;
                    font-size: 16px;
                    color: @text-color-title;
                    font-weight: 700;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    width: 100%;
                }

                .chart-center-style {
                    width: 70px;
                    flex-shrink: 0;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #1477C9;
                    font-size: 12px;

                    z-index: 9;

                    .jiantou {
                        display: inline-block;
                        height: 1px;
                        width: 44px;
                        background: #F2F6FE;
                        border: 1px dashed #1477C9;
                        margin-bottom: 5px;
                        position: relative;

                        &::before {
                            content: "";
                            display: block;
                            width: 0;
                            height: 0;
                            border: 6px solid transparent;
                            border-left-color: #1477C9;
                            position: absolute;
                            right: -12px;
                            top: -6px;
                        }
                    }
                }

            }
        }
    }
}

.header-lable .iconfont{
  position: relative;
  top: -6px;
}
</style>